import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0,
  src: "https://www.mimodental.com/assets/imgData/imgs/hy_bg.png",
  class: "hy_bg"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CommonHeader = _resolveComponent("CommonHeader");
  const _component_router_view = _resolveComponent("router-view");
  const _component_CommonFooter = _resolveComponent("CommonFooter");
  const _component_service = _resolveComponent("service");
  return _openBlock(), _createElementBlock(_Fragment, null, [_ctx.getShowTask && _ctx.Client == 0 ? (_openBlock(), _createElementBlock("img", _hoisted_1)) : _createCommentVNode("", true), !_ctx.is_login ? (_openBlock(), _createBlock(_component_CommonHeader, {
    key: 1
  })) : _createCommentVNode("", true), (_openBlock(), _createBlock(_component_router_view, {
    key: _ctx.$route.path,
    style: _normalizeStyle('margin-bottom:' + (_ctx.is_show ? '150px;' : '0'))
  }, null, 8, ["style"])), !_ctx.is_login ? (_openBlock(), _createBlock(_component_CommonFooter, {
    key: 2
  })) : _createCommentVNode("", true), _createVNode(_component_service), _createElementVNode("div", {
    class: "chat",
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.openKf && _ctx.openKf(...args)),
    style: _normalizeStyle('font-size:' + (_ctx.Client == 0 ? '1rem;' : '2rem;') + 'bottom:' + (_ctx.Client == 0 ? '20px;' : '150px;'))
  }, [_createElementVNode("img", {
    style: _normalizeStyle('width:' + (_ctx.Client == 0 ? '60px;' : '8rem;')),
    src: "https://www.mimodental.com/assets/imgData/imgs/CustomerConversation.png",
    alt: ""
  }, null, 4), _cache[1] || (_cache[1] = _createElementVNode("span", null, "在线客服", -1))], 4)], 64);
}